import React from 'react';
import { generatePath } from 'react-router-dom';
import PropTypes from 'prop-types';
import RouterLink from '@/components/common/RouterLink';
import AuthRoutes from '@/constants/routing/AuthRoutes';

export default function CampaignLink({ campaignDisplayName, campaignId }) {
  return (
    <RouterLink to={generatePath(AuthRoutes.CAMPAIGN, { campaignId })}>
      {campaignDisplayName}
    </RouterLink>
  );
}

CampaignLink.propTypes = {
  campaignDisplayName: PropTypes.string.isRequired,
  campaignId: PropTypes.string.isRequired,
};
